module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/eyecatch-plan-b-ba879ab020b8ce27b35085f57112a99e.jpg";